import { render, staticRenderFns } from "./koulutussopimus-readonly.vue?vue&type=template&id=c682877e&"
import script from "./koulutussopimus-readonly.vue?vue&type=script&lang=ts&"
export * from "./koulutussopimus-readonly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports